module.exports = __webpack_public_path__ + "static/img/lbfg@2x.c621362.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile/lbfg@2x.png
// module id = LCxw
// module chunks = 1